module.exports = __webpack_public_path__ + "img/2.3_Associate-Investigators_3_Gray.1965f7bb1f33596c0b8ad4778c82bb93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.3_Associate-Investigators_3_Gray.png
// module id = 759
// module chunks = 0